export const Permissions = {
  create: "create:Faq",
  read: "read:Faq",
  list: "list:Faq",
  update: "update:Faq",
  delete: "delete:Faq",
};
